import { FC, useState } from 'react';
import AboutFour from './components/AboutFour';

type IProductProps = object;

const Product: FC<IProductProps> = () => {
  return (
    <div className='mt-10'>
      <AboutFour />
    </div>
  );
};

export default Product;
